const FRONTDESK_PATH = '/vms/checkin/frontdesk';
const LEGACY_CHECKIN_PATH = '/vms/checkin';
const FRONTDESK_PERMISSION_MODULE = 'check-in';
const FRONTDESK_PERMISSION_NAMES = ['visitor', 'courier'];
const LEGACY_PERMISSION_MODULE = 'customer';
const LEGACY_PERMISSION_NAME = 'check-in';

const normalizeName = (value) => value?.trim().toLowerCase();
const hasPermissionAccess = (perm) => perm?.access !== false;

const hasMatchingPermission = (moduleName, expectedNames, permissions = []) =>
  permissions.some((mod) => normalizeName(mod.module_name) === normalizeName(moduleName) &&
    mod.permissions?.some((perm) => expectedNames.includes(normalizeName(perm.name)) && hasPermissionAccess(perm))
  );

export const hasFrontdeskCheckInPermission = (permissions = []) =>
  hasMatchingPermission(FRONTDESK_PERMISSION_MODULE, FRONTDESK_PERMISSION_NAMES, permissions);

export const hasLegacyCheckInPermission = (permissions = []) =>
  hasMatchingPermission(LEGACY_PERMISSION_MODULE, [LEGACY_PERMISSION_NAME], permissions);

export const hasCheckInAccess = (permissions = [], isReceptionist = false) =>
  isReceptionist || hasFrontdeskCheckInPermission(permissions) || hasLegacyCheckInPermission(permissions);

export const hasBothCheckInFlows = (permissions = [], isReceptionist = false) => {
  if (isReceptionist) return false;
  return hasFrontdeskCheckInPermission(permissions) && hasLegacyCheckInPermission(permissions);
};

export const getCheckInDestination = (permissions = [], isReceptionist = false) => {
  if (isReceptionist) {
    return FRONTDESK_PATH;
  }

  if (hasLegacyCheckInPermission(permissions)) {
    return LEGACY_CHECKIN_PATH;
  }

  if (hasFrontdeskCheckInPermission(permissions)) {
    return FRONTDESK_PATH;
  }

  return LEGACY_CHECKIN_PATH;
};
